<template>
  <div id="app">
    <div v-if="hiddenHeader === true">
      <router-view/>
    </div>
    <div v-else>
      <appHeader v-bind:headerType="headerType"/>
      <transition name="fade" mode="out-in"/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import appHeader from '@/components/Header.vue'

export default {
  components: {
    appHeader
  },
  props: ['headerType'],
  data: function () {
    return {
      hiddenHeader: false,
      hiddenHeaderRouterName: [
        'archive-return-prints'
      ]
    }
  },
  created () {
    this.hiddenHeader = this.hiddenHeaderRouterName.includes(this.$route.name)
    window.addEventListener('beforeunload', this.clearRemarkLock)
  },
  beforeDestroy: function () {
    window.removeEventListener('beforeunload', this.clearRemarkLock)
  },
  methods: {
    clearRemarkLock () {
      if (this.isLogged) {
        let url = this.$api_url.shipping_instructions + `/cancel_remark?warehouse_id=${this.selectWarehouseId}&&shipping_at=${this.shippingDate}`
        this.$http.get(url)
      }
    }
  }
}
</script>

<style>
a, [pointer]{
  cursor: pointer;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before, table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before, table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before, table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before, table.dataTable thead .sorting_desc_disabled:after {
  font-family: "Font Awesome 5 Free" !important;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before, table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
  right: 1.5em !important;
  content: "\f0d7" !important;
  top: 0.9em !important;
  /* display: none !important */
}

table.dataTable thead .sorting:after, table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after, table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  right: 1.5em !important;
  content: "\f0d8" !important;
  top: 0.4em !important;
  /* display: none !important; */
}

#tbl-users_wrapper table.dataTable, #tbl-estimates_wrapper table.dataTable, #tbl-sales_wrapper table.dataTable, #tbl-orders_wrapper table.dataTable, #tbl-invoices_wrapper table.dataTable, #tbl-payments_wrapper table.dataTable, #tbl-stocks_wrapper table.dataTable, #tbl-inventories_wrapper table.dataTable, #tbl-accounts-receivable_wrapper table.dataTable, #tbl-accounts-payable_wrapper table.dataTable, #tbl-withdrawals_wrapper table.dataTable {
  margin-top: 0 !important;
}
.table-scroll.mb-4.velmld-parent {
  position: static !important;
}
.dataTables_paginate{
 margin-top: 25px;
}
table.dataTable thead th {
  border-bottom: 0px;
}
</style>
